"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M9 4v3h5v12h3V7h5V4zm-6 8h3v7h3v-7h3V9H3z"
}), 'FormatSizeSharp');